import {Component, Host, h, Prop, Event, EventEmitter, getAssetPath, Watch} from '@stencil/core';
import {Logger} from "../../utils/logger";

@Component({
  tag: 'securecall-request-secure-pan',
  styleUrl: 'securecall-request-secure-pan.css',
  shadow: true,
  assetsDirs: ['assets']
})
export class SecurecallRequestSecurePan {
  @Prop() fieldName: string;
  @Prop() config: any;

  @Event() secureFieldResetEvent: EventEmitter<string>;

  private readonly log = Logger('SecurecallRequestSecurePan')

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    this.log.debug(this.fieldName + ": handleConfigChange: config", newConfig, oldConfig);
  }

  handleClick(ev) {
    ev.preventDefault();
    this.log.debug("handleClick: field", this.fieldName, "clicked");
    this.config.valid = false;
    this.secureFieldResetEvent.emit(this.fieldName)
  }

  cardIconMap() {
    let iconList;

    iconList = (this.config.brands) ? this.config.brands : []
    return iconList.map(brand => {
      return <span><img class="brand-icon" src={getAssetPath(`assets/icons/${brand}.svg`)}/></span>
    })
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>
            {this.config["label"]}: {this.config.active}
          </label>
          <div class="input-container">
            <input
              type="text"
              class={`custom-input ${this.config.active ? 'active' : 'inactive'}`}
              id={this.fieldName}
              readOnly
              placeholder={this.config.value}>
            </input>
            <div class="brand-icons-overlay">
              {this.cardIconMap()}
            </div>
          </div>
          <div class={{validity: true, valid: this.config.valid}} onClick={(ev) => this.handleClick(ev)}></div>
        </div>
      </Host>
  );
  }
  }
